

















































import DatePicker from "@/components/pickers/date-picker.vue";
import FloorSelector from "@/components/pickers/floor-selector.vue";
import TimePicker from "@/components/pickers/time-picker.vue";
import { useFloorplanStore } from "@/pinia/floorplan-store";
import { useRouter } from "@/router/router";
import FloorplanControls from "@/views/floorplan/controls.vue";
import FloorplanLegend from "@/views/floorplan/legend.vue";
import FloorplanMap from "@/views/floorplan/map.vue";
import SidebarEditEmpty from "@/views/floorplan/sidebar-edit-empty.vue";
import SidebarEdit from "@/views/floorplan/sidebar-edit.vue";
import sidebarReservationsEmpty from "@/views/floorplan/sidebar-reservations-empty.vue";
import SidebarReservations from "@/views/floorplan/sidebar-reservations.vue";
import { defineComponent, onMounted } from "@vue/composition-api";
import alert from "@/components/misc/alert.vue";

export default defineComponent({
    name: "floorplan",
    components: {
        alert,
        SidebarEdit,
        SidebarEditEmpty,
        SidebarReservations,
        sidebarReservationsEmpty,
        FloorplanLegend,
        FloorplanControls,
        FloorplanMap,
        TimePicker,
        DatePicker,
        FloorSelector,
    },
    setup(props, ctx) {
        const floorplanStore = useFloorplanStore();
        const { route } = useRouter(ctx);

        onMounted(async () => {
            // todo: catch err
            await floorplanStore.loadOffice(parseInt(route.value.params.officeId));
        });

        return { floorplanStore };
    },
});
